<app-create-pharmacy-component />
